import React from 'react';
import { SUNLOCK_STATUS_ACTIVE } from 'common/sunlocks/sunlockConstants';

import useSunlockStatusController from 'client/components/SrSunlockStatus/useSunlockStatusController';

import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrSunlockCommandsLogModal from 'client/components/SrSunlockCommandsLogModal/SrSunlockCommandsLogModal';

const SrSunlockStatus = ({
  listingAddress,
  sunlockStatus,
  sunlockSerial,
  sunlockLastPingDate,
  sunlockLogs,
  internetConnection,
  onFixSunlockConnectionClick,
}) => {
  const { status, connectivity, logsModal, actions } = useSunlockStatusController({
    sunlockStatus,
    sunlockSerial,
    sunlockLastPingDate,
    sunlockLogs,
    internetConnection,
    onFixSunlockConnectionClick,
  });

  return (
    <SrBox padding="15px 0px" marginBottom="12px">
      <SrText font="greycliff" fontSize="21px" weight="800" letterSpacing="0">
        Sunlock Status
      </SrText>
      <SrBox>
        <SrFlex marginTop="8px">
          <SrFlex width="25px" justify="center" paddingTop="4px">
            <SrBox width="20px" height="20px" backgroundImage={`url(${status.icon})`} />
          </SrFlex>
          <SrBox marginLeft="5px" minWidth="200px">
            <SrText font="greycliff" weight="700">
              {status.title}
            </SrText>
            <SrText font="greycliff" weight="500" color="grey" fontSize="16px" paddingLeft="5px">
              &nbsp;{status.details}&nbsp;
              <SrText
                onClick={logsModal.open}
                decoration="underline"
                font="greycliff"
                cursor="pointer"
                color="blue300"
                weight="600"
              >
                See Logs
              </SrText>
            </SrText>
          </SrBox>
        </SrFlex>
      </SrBox>
      {sunlockStatus !== SUNLOCK_STATUS_ACTIVE && (
        <SrBox padding="8px">
          <SrText
            onClick={actions.onFixSunlockConnectionClick}
            font="greycliff"
            cursor={connectivity.shouldShowTroubleshooting ? 'pointer' : 'default'}
            color="blue300"
            fontSize="12px"
            lineHeight="20px"
            weight="500"
          >
            {'Looks like the Sunlock has not connected to the internet ' +
              `${connectivity.lastActiveFor}. 
              ${connectivity.shouldShowTroubleshooting ? ' See how you can fix it ->' : ''}`}
          </SrText>
        </SrBox>
      )}
      {logsModal.isOpen && (
        <SrSunlockCommandsLogModal
          onClose={logsModal.close}
          address={listingAddress}
          sunlockStatus={sunlockStatus}
          lastPingDate={connectivity.lastPingDate}
          sunlockSerial={sunlockSerial}
          sunlockLogs={sunlockLogs}
        />
      )}
    </SrBox>
  );
};

export default SrSunlockStatus;
